import { ExclamationCircleOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { Modal } from 'antd';
import { useRecoilState } from 'recoil';
import { Confirmation, initialConfirmationState } from 'schemas';

export default function ConfirmDialog() {
    const [modal, contextHolder] = Modal.useModal();
    const [openConfirm, setOpenConfirm] = useRecoilState(Confirmation);
    
    const onConfirm = () => setOpenConfirm(prev => ({ ...prev, open: false, confirmed: true }));
    const onCancel = () => setOpenConfirm(initialConfirmationState);
    
    useEffect(() => {
        if (openConfirm?.open) {
            modal.confirm({
                title: openConfirm?.title ?? 'Confirmação',
                icon: <ExclamationCircleOutlined />,
                content: openConfirm?.msg,
                okText: 'Sim',
                cancelText: 'Não',
                onCancel: onCancel,
                onOk: onConfirm,
                zIndex: 22000 // Remove quotes - should be a number
            });
        }
    }, [openConfirm?.open]); // Trigger when open state changes
    
    return (
        <>
            {contextHolder}
        </>
    );
}
